<div>
    <button *ngIf="!edit_all_tabs" (click)="enableTabEditing()"><fa-icon [icon]="edit_icon" class="fa-lg" /></button>
    <button *ngIf="edit_all_tabs" (click)="cancelEditing()"><fa-icon [icon]="cancel_icon" class="fa-lg" /></button>
    <button *ngIf="edit_all_tabs" (click)="saveEditing()"><fa-icon [icon]="save_icon" class="fa-lg" /></button>
    <mat-tab-group>
        <!-- ORDER SUMMARY -->
        <mat-tab label="Order Summary">
            <div class="tab" [formGroup]="order_summary_forms">
                <div class="tab-section" [formGroup]="order_summary_forms">
                    <h3 class="tab-section-title">Organizations</h3>
                    <div class="long-text-div">
                        <div class="info-label">Customer</div>
                        <div>{{lading_details.customer_name}}</div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Shipper</div>
                        <div>{{lading_details.shipper_name}}</div>
                         <div *ngFor="let str of addresses.shipper">
                            <div>{{str}}</div>
                        </div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Consignee</div>
                        <div>{{lading_details.consignee_name}}</div>
                        <div *ngFor="let str of addresses.consignee">
                            <div>{{str}}</div>
                        </div>
                    </div>
                    <button (click)="openMap()" class="btn">See Trip as Map</button>
                    <!-- <mat-checkbox class="checkbox" formControlName="hot">Hot</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="drop_trailer">Drop Trailer</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="expedited">Expedited</mat-checkbox> -->
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Order Information</h3>
                    <div class="short-text-div">
                        <div class="info-label">Work Order</div>
                        <div>{{lading_details.alternate_reference}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Manifest</div>
                        <div>{{lading_details.lading_id}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Pro Bill</div>
                        <div>{{lading_details.pro_bill}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">BOL</div>
                        <div>{{lading_details.lading_number}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Customer PO</div>
                        <div>{{lading_details.customer_po}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Actual Weight</div>
                        <div>{{lading_details.load_weight_actual}} {{lading_details.load_weight_unit}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Pieces</div>
                        <div>{{lading_details.load_pieces}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Pallets</div>
                    <div>{{lading_details.load_pallets}}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Load Length</div>
                        <div>{{lading_details.load_length}}</div>
                    </div>
                    <mat-form-field>
                        <mat-label>Load Details</mat-label>
                        <input matInput name="load_details" formControlName="load_details">
                    </mat-form-field>
                    <div class="long-text-div" [formGroup]="order_summary_forms">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Seal Number</mat-label>
                            <input matInput formControlName="seal_number">
                        </mat-form-field>
                    </div>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Pickup and Delivery</h3>
                    <!-- <div class="long-text-div">
                        <div class="info-label">Delivery Appointment</div>
                         <div *ngIf="!lading_details.appointment_date">not set</div>
                        <div *ngIf="lading_details.appointment_date">{{formatDate(lading_details.appointment_date.substring(0,10))}}</div>
                        <div *ngIf="lading_details.appointment_date">{{lading_details.appointment_start}}-{{lading_details.appointment_end}}</div>
                    </div> -->
                    <div style="display:flex;flex-direction:column">
                        <!-- <div>{{details.load_start ? formatDatetime(details.load_start) : "not set"}}</div> -->
                        <div class="short-text-div">
                            <div class="info-label">Scheduled Pickup</div>
                            <div>{{lading_details.load_start ? lading_details.load_start + ' ET' : 'Date not set'}}</div>
                        </div>
                        <div class="short-text-div">
                            <div class="info-label">Scheduled Delivery</div>
                            <div>{{lading_details.load_end ? lading_details.load_end + ' ET' : 'Date not set'}}</div>
                        </div>
                        <div class="short-text-div" *ngIf="lading_details?.appointment_start && lading_details?.appointment_end">
                            <div class="info-label">Appointment</div>
                            <div *ngIf="lading_details.appointment_start">{{lading_details.appointment_start.substring(0,16)}}-{{lading_details.appointment_end.substring(11,16)}} ET</div>
                            <div *ngIf="!lading_details.appointment_start">Date not set</div>
                        </div>
                        <button (click)="openPickupModal()">Edit Pickup</button>
                        <button (click)="openDeliveryModal()">Edit Delivery</button>
                        <button (click)="openAppointmentModal()">Edit Appointment</button>
                        <button (click)="removeAppointment()" *ngIf="lading_details?.appointment_start || lading_details?.appointment_end">Remove Appointment</button>
                        <!-- <mat-form-field appearance="outline" floatLabel="always">
                            <input matInput [matDatepicker]="load_start_picker" formControlName="load_start_date"
                                placeholder="Date not set" />
                            <mat-datepicker-toggle matIconSuffix [for]="load_start_picker"></mat-datepicker-toggle>
                            <mat-datepicker #load_start_picker>
                                <mat-datepicker-actions>
                                    <button mat-button matDatepickerCancel>Cancel</button>
                                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                                </mat-datepicker-actions>
                            </mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" floatLabel="always">
                            <input matInput type="time" formControlName="load_start_time" />
                        </mat-form-field> -->
                    </div>

<!-- 
                    <div style="display:flex;flex-direction:column">
                        <div class="info-label">Scheduled Delivery</div>
                        <mat-form-field appearance="outline" floatLabel="always">
                            <input matInput [matDatepicker]="load_end_picker" formControlName="load_end_date"
                                placeholder="Date not set" />
                            <mat-datepicker-toggle matIconSuffix [for]="load_end_picker"></mat-datepicker-toggle>
                            <mat-datepicker #load_end_picker>
                                <mat-datepicker-actions>
                                    <button mat-button matDatepickerCancel>Cancel</button>
                                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                                </mat-datepicker-actions>
                            </mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" floatLabel="always">
                            <input matInput type="time" formControlName="load_end_time" />
                        </mat-form-field>
                    </div> -->
                </div>
                <div class="tab-section" id="status-timeline">
                    <h3 class="tab-section-title">Status Timeline</h3>
                    <table id="status_timeline_table">
                        <thead>
                            <tr>
                                <th scope="col" class="status_col">Status</th>
                                <th scope="col" class="status_col">Date</th>
                                <th scope="col" class="status_col">Time</th>
                            </tr>
                        </thead>
                        <ng-container *ngIf="this.lading_statuses.length > 0">
                            <tbody>
                                <tr *ngFor="let status of this.lading_statuses">
                                    <td>{{status.lading_status}}</td>
                                    <td>{{status.local_time != null ? formatDate(status.local_time.substring(0,10)) :
                                        formatDate(status.created.substring(0,10))}}</td>
                                    <td>{{status.local_time != null ? status.local_time.substring(11,16) :
                                        status.created.substring(11,16)}}</td>
                                </tr>
                            </tbody>
                        </ng-container>
                    </table>
                    <button class="btn" (click)="openStatusModal()">Add Status</button>
                    <button class="btn" (click)="cancelLading()">Cancel Order</button>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Financials Summary</h3>
                    <div class="short-text-div">
                        <div class="info-label">Total Cost</div>
                        <div>{{ ((details?.financials?.total_cost ?? 0) / 100) | number:'1.2-2' }}</div>
                    </div>
                    <div class="short-text-div">
                        <div class="info-label">Total Charged</div>
                        <div>{{ ((details?.financials?.total_billed ?? 0) / 100) | number:'1.2-2' }}</div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Note</div>
                        <div>{{ details?.financials?.note ?? ''}}</div>
                    </div>
                </div>
                <div class="tab-section" style="display:flex;justify-content:flex-start">
                    <h3 class="tab-section-title">Print/Full Details</h3>
                    <button class="btn" (click)="printBOL(lading_details.lading_uuid, lading_details.alternate_reference, lading_details.shipper_contact_uuid)">Print Bill Of Lading</button>
                    <button class="btn" (click)="printLabel('packing')">Print Packing Label</button>
                    <button class="btn" (click)="printLabel('pallet')">Print Pallet Labels</button>
                    <button class="btn" (click)="printLabel('trailer')">Print Trailer Labels</button>
                    <button class="btn" (click)="openFullDetails()">Full Details</button>
                </div>
            </div>
        </mat-tab>
        <!-- OPERATIONS / CUSTOMER CARE -->
        <mat-tab label="Operations/Customer Care">
            <div class="tab">
                <div class="tab-section" [formGroup]="ops_forms">
                    <h3 class="tab-section-title">Operations</h3>
                    <mat-checkbox class="checkbox" formControlName="carrier_rated">Carrier Rated</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="carrier_rerated">Carrier Rerated</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="straps_bars">Straps and Bars</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="lift_lull">Forklift or Lull</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="call_site">Call Site</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="protective_equipment">Protective
                        Equipment</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="unmanned_job_site">Unmanned Job Site</mat-checkbox>
                </div>
                <div class="tab-section" [formGroup]="ops_forms">
                    <h3 class="tab-section-title">Operations Notes</h3>
                    <textarea matInput rows="10" formControlName="operations_notation"></textarea>
                </div>
                <div class="tab-section" [formGroup]="ops_forms">
                    <h3 class="tab-section-title">KPIs</h3>
                    <div style="display:grid;grid-template-columns: repeat(2,1fr);grid-gap:5px">
                        <mat-checkbox class="checkbox" formControlName="loaded_odot">Trailer Loaded ODOT</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="loading_delay">Freight Loading
                            Delay</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="document_delay">Customs Document
                            Delay</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="border_delay">Border Delay</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="customs_inspection">Customs
                            Inspection</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="trailer_unavailable">Trailer
                            Unavailable</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="driver_unavailable">Driver/Tractor
                            Unavailable</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="driver_hos">Driver HOS</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="mechanical_delay">Mechanical
                            Delay</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="trailer_switch">Carrier Trailer
                            Switch</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="weather_delay">Weather Delay</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="dock_waiting">Dock Availability
                            (Waiting)</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="dock_re_delivery">Dock Availability
                            (Re-Delivery)</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="scheduled_holiday">Scheduled
                            Holiday</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="carrier_reneged">Original Carrier
                            Reneged</mat-checkbox>
                    </div>
                </div>
                <div class="tab-section" [formGroup]="cares_forms">
                    <h3 class="tab-section-title">Customer Care</h3>
                    <mat-checkbox class="checkbox" formControlName="confirm_pick_up">Confirm Pickup</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="confirm_delivery">Confirm Delivery</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="pod_required">POD Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="purchase_order_required">Purchase Order
                        Required</mat-checkbox>
                </div>
                <div class="tab-section" [formGroup]="cares_forms">
                    <h3 class="tab-section-title">Care Notation</h3>
                    <textarea matInput rows="10" formControlName="care_notation"></textarea>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Carrier">
            <div class="tab">
                <div class="tab-section">
                    <h3 class="tab-section-title"></h3>
                    <div [formGroup]="new_carrier_forms">
                        <!-- <div class="info-label">Carrier</div>
                        <div>{{lading_details.carrier_name}}</div> -->
                        <mat-form-field appearance="outline" floatLabel="always" style="width:33%">
                            <mat-label>Carrier</mat-label>
                            <input matInput [placeholder]="lading_details.carrier_name"
                                [matAutocomplete]="carrierAutocomplete" formControlName="carrier_contact_control">
                        </mat-form-field>
                        <mat-autocomplete #carrierAutocomplete="matAutocomplete">
                            <mat-option *ngFor="let item of filteredCarrierList | async" [value]="item">
                                <span>{{item}}</span>
                            </mat-option>
                        </mat-autocomplete>
                        <!-- <mat-form-field *ngIf="edit_all_tabs">
                            <mat-label>Carrier Address</mat-label>
                            <input matInput formControlName="carrier_address_uuid">
                        </mat-form-field> -->
                    </div>
                    <div [formGroup]="new_carrier_forms" *ngIf="edit_all_tabs">
                        <mat-form-field>
                            <mat-label>Carrier Address</mat-label>
                            <mat-select [(value)]="carrierAddresses[0]">
                                <mat-option *ngFor="let type of carrierAddresses" [value]="type">
                                    {{type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <input type="hidden" formControlName="carrier_address_uuid">
                        <input type="hidden" formControlName="carrier_contact_uuid">
                        <input type="hidden" formControlName="old_carrier_task_uuid">
                    </div>
                    <div [formGroup]="carrier_reneged_form">
                        <mat-checkbox class="checkbox" formControlName="did_carrier_reneged">Switch is because carrier
                            reneged</mat-checkbox>
                    </div>
                    <div *ngIf="carrier_reneged_form.get('did_carrier_reneged')?.value"
                        [formGroup]="carrier_reneged_form">
                        <mat-form-field>
                            <mat-label>Reason Carrier Reneged</mat-label>
                            <mat-select formControlName="carrier_reneged_reason">
                                <mat-option *ngFor="let reason of renege_reason | keyvalue"
                                    [value]="reason.key">{{reason.value}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-tab>
        <!-- SHIPPER -->
        <mat-tab label="Shipper">
            <div class="tab" [formGroup]="shipper_forms">
                <div class="tab-section">
                    <h3 class="tab-section-title">Basic Information</h3>
                    <div class="long-text-div">
                        <div class="info-label">Organization</div>
                        <div>{{details.shipper_name}}</div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Location</div>
                        <div>{{addresses.shipper[1]}}</div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Full Address</div>
                        <div>{{addresses.shipper[0]}}</div>
                        <div>{{addresses.shipper[1]}}</div>
                        <div>{{addresses.shipper[2]}}</div>
                    </div>
                    <mat-checkbox formControlName="pickup_reference_number_required" style="padding-bottom:0.3em">Pickup
                        Reference Required</mat-checkbox>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Pickup Reference Number</mat-label>
                        <input matInput formControlName="pickup_reference_number">
                    </mat-form-field>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Site Information</h3>
                    <mat-checkbox class="checkbox" formControlName="loading_dock">Loading Dock</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="pickup_tailgate">Tailgate Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="truck_space">Truck Space</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="appointment">Appointment Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="call_site">Call Site</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="shipping_bol_required">Shipping BOL
                        Required</mat-checkbox>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Site Type</h3>
                    <mat-checkbox class="checkbox" formControlName="commercial">Commercial</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="residential">Residential</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="job_site">Job Site</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="unmanned_job_site">Unmanned Job Site</mat-checkbox>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Contacts</h3>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Job Site Contact Name</mat-label>
                        <input matInput formControlName="job_site_contact_name">
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Job Site Contact Phone</mat-label>
                        <input matInput formControlName="job_site_contact_phone">
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Appt Contact Name</mat-label>
                        <input matInput formControlName="appointment_contact_name">
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Appt Contact Phone</mat-label>
                        <input matInput formControlName="appointment_contact_phone">
                    </mat-form-field>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Notification Requirements</h3>
                    <mat-checkbox class="checkbox" formControlName="notification_at_pickup">At Pickup</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_delayed_pickup">Delayed
                        Pickup</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_at_delivery">At Delivery</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_delayed_delivery">Delayed
                        Delivery</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_assessorials_incured">Assessorials
                        Incured</mat-checkbox>
                </div>
            </div>
        </mat-tab>
        <!-- CONSIGNEE -->
        <mat-tab label="Consignee">
            <div class="tab" [formGroup]="consignee_forms">
                <div class="tab-section">
                    <h3 class="tab-section-title">Basic Information</h3>
                    <div class="long-text-div">
                        <div class="info-label">Organization</div>
                        <div>{{details.consignee_name}}</div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Location</div>
                        <div>{{addresses.consignee[1]}}</div>
                    </div>
                    <div class="long-text-div">
                        <div class="info-label">Full Address</div>
                        <div>{{addresses.consignee[0]}}</div>
                        <div>{{addresses.consignee[1]}}</div>
                        <div>{{addresses.consignee[2]}}</div>
                    </div>
                    <mat-checkbox style="padding-bottom:0.3em"
                        formControlName="delivery_reference_number_required">Delivery Reference Required</mat-checkbox>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Delivery Reference Number</mat-label>
                        <input matInput formControlName="delivery_reference_number">
                    </mat-form-field>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Site Information</h3>
                    <mat-checkbox class="checkbox" formControlName="loading_dock">Loading Dock</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="pickup_tailgate">Tailgate Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="truck_space">Truck Space</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="appointment">Appointment Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="call_site">Call Site</mat-checkbox>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Site Type</h3>
                    <mat-checkbox class="checkbox" formControlName="commercial">Commercial</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="residential">Residential</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="job_site">Job Site</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="unmanned_job_site">Unmanned Job Site</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="convention_center">Convention Center</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="pop_up_store">Pop-up Store</mat-checkbox>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Contacts</h3>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Job Site Contact Name</mat-label>
                        <input matInput formControlName="job_site_contact_name">
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Job Site Contact Phone</mat-label>
                        <input matInput formControlName="job_site_contact_phone">
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Appt Contact Name</mat-label>
                        <input matInput formControlName="appointment_contact_name">
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Appt Contact Phone</mat-label>
                        <input matInput formControlName="appointment_contact_phone">
                    </mat-form-field>
                </div>
                <div class="tab-section">
                    <h3 class="tab-section-title">Notification Requirements</h3>
                    <mat-checkbox class="checkbox" formControlName="notification_at_pickup">At Pickup</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_delayed_pickup">Delayed
                        Pickup</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_at_delivery">At Delivery</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_delayed_delivery">Delayed
                        Delivery</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="notification_assessorials_incured">Assessorials
                        Incured</mat-checkbox>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Customer">
            <div class="tab" style="width:50%" [formGroup]="customer_forms">
                <div class="tab-section">
                    <h3 class="tab-section-title">Document Requirements</h3>
                    <mat-checkbox class="checkbox" formControlName="bol_required">BOL</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="invoice_bol_required">Invoice BOL</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="rate_quote_required">Rate Quote</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="invoice_po_required">Invoice PO</mat-checkbox>
                    <mat-form-field floatLabel="always" appearance="outline">
                        <mat-label>Invoice PO</mat-label>
                        <input matInput formControlName="invoice_po">
                    </mat-form-field>
                </div>
                <div class="tab-section">
                    <mat-checkbox class="checkbox" formControlName="pickup_reference_number_required">Pickup Reference
                        Number Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="delivery_reference_number_required">Delivery
                        Reference Number Required</mat-checkbox>
                </div>
                <div class="tab-section" style="display:flex;justify-content:flex-start">
                    <h3 class="tab-section-title">Installation Forms</h3>
                    <button class="btn" *ngIf="formButtons.inservice"
                        [disabled]="!formButtons.inservice.includes('?token=')"
                        (click)="navigateTo(formButtons.inservice)">
                        Installation Service
                    </button>

                    <button class="btn" *ngIf="formButtons.checklist"
                        [disabled]="!formButtons.checklist.includes('?token=')"
                        (click)="navigateTo(formButtons.checklist)">
                        Installation Checklist
                    </button>

                    <button class="btn" *ngIf="formButtons.disclaimer"
                        [disabled]="!formButtons.disclaimer.includes('?token=')"
                        (click)="navigateTo(formButtons.disclaimer)">
                        Equipment Disclaimer
                    </button>

                    <button class="btn" *ngIf="formButtons.inagreement"
                        [disabled]="!formButtons.inagreement.includes('?token=')"
                        (click)="navigateTo(formButtons.inagreement)">
                        Installation Agreement
                    </button>

                    <button class="btn" *ngIf="formButtons.sitesurvey"
                        [disabled]="!formButtons.sitesurvey.includes('?token=')"
                        (click)="navigateTo(formButtons.sitesurvey)">
                        Site Survey
                    </button>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Sales/Admin">
            <div class="tab">
                <div class="tab-section" [formGroup]="sales_forms">
                    <h3 class="tab-section-title">Sales</h3>
                    <mat-checkbox class="checkbox" formControlName="quote_required">Quote Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="requote_required">Requote Required</mat-checkbox>
                    <mat-checkbox class="checkbox" formControlName="customer_rated">Customer Rated</mat-checkbox>
                </div>
                <div class="tab-section" [formGroup]="sales_forms">
                    <div class="tab-section-title">Sales Notation</div>
                    <textarea matInput rows="10" formControlName="sales_notation"></textarea>
                </div>
                <div class="tab-section" [formGroup]="sales_forms">
                    <div class="tab-section-title">Management Notation</div>
                    <textarea matInput rows="10" formControlName="management_notation"></textarea>
                </div>
                <div class="tab-section" [formGroup]="admin_forms">
                    <div class="tab-section-title">Administration</div>
                    <div style="display:grid;grid-template-columns: repeat(2,1fr);grid-gap:5px">
                        <mat-checkbox class="checkbox" formControlName="po_audited">PO Audited</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="confirm_charges">Confirm Charges</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="freight_cost_approved">Freight Cost
                            Approved</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="ready_invoice">Ready Invoice</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="intent_claim">Intent Claim</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="invoice_thanks">Invoice Thanks</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="pod_audited">POD Audited</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="carrier_invoiced">Carrier
                            Invoiced</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="freight_cost_exception">Freight Cost
                            Exception</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="damage_claim">Damage Claim</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="claim_review">Claim Review</mat-checkbox>
                        <mat-checkbox class="checkbox" formControlName="invoice_due">Invoice Due</mat-checkbox>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Products/Packages">
            <div class="vertical-lists">
                <div>
                    <span style="font-size:1.5em">Products</span>
                    <ul class="nice-list" style="overflow:scroll;max-height:400px">
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                
                <div>
                    <span style="font-size:1.5em">Packages</span>
                    <ul class="nice-list">
                        <li>
                            <div class="list-item-content">
                                <h3>Package Number</h3>
                                <p class="list-item-details">
                                    Other package details<br>
                                    More package details
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Package Number</h3>
                                <p class="list-item-details">
                                    Other package details<br>
                                    More package details
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Package Number</h3>
                                <p class="list-item-details">
                                    Other package details<br>
                                    More package details
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div>
                    <span style="font-size:1.5em">Requested Products</span>
                    <ul class="nice-list">
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-item-content">
                                <h3>Product Model Number</h3>
                                <p class="list-item-details">
                                    Product Description<br>
                                    Quantity
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<dialog #statusDialog>
    <div [formGroup]="lading_status_form">
        <mat-form-field>
            <mat-label>Lading Status</mat-label>
            <mat-select formControlName="status">
                <mat-option *ngFor="let status of lading_status_options" [value]="status">
                    {{status}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="lading_status_datepicker" formControlName="date" />
            <mat-datepicker-toggle matIconSuffix [for]="lading_status_datepicker"></mat-datepicker-toggle>
            <mat-datepicker #lading_status_datepicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>
            </mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Time</mat-label>
            <input matInput type="time" formControlName="time" />
        </mat-form-field>
    </div>
    <mat-dialog-actions>
        <button mat-button (click)="statusDialog.close()">Cancel Status Change</button>
        <button mat-button (click)="submitNewStatus()">Save</button>
    </mat-dialog-actions>
</dialog>
<app-lading-status-modal *ngIf="isStatusModalOpen" (closeModal)="closeStatusModal($event)"
    [lading_uuid]="lading_uuid"></app-lading-status-modal>
<app-scheduled-time-modal *ngIf="isDatetimeModalOpen" (closeModal)="closePickupModal($event)"
[lading_uuid]="lading_uuid" field="pickup"></app-scheduled-time-modal>
<app-scheduled-time-modal *ngIf="isDeliveryeModalOpen" (closeModal)="closeDeliveryModal($event)"
[lading_uuid]="lading_uuid" field="delivery"></app-scheduled-time-modal>
<app-scheduled-time-modal *ngIf="isAppointmentModalOpen" (closeModal)="closeAppointmentModal($event)"
[lading_uuid]="lading_uuid" field="appointment"></app-scheduled-time-modal>